import { useState, useEffect, useContext } from 'react'
import ContextStates from '../../context/ContextStates';
import axios from 'axios';
import { Url } from '../Url';
import { FaBox, FaUser, FaCheckCircle, FaSave, FaCheck, FaTruck } from 'react-icons/fa';


const FormRepartosView = () => {
    const [productos, setProductos] = useState([])
    const [usuarios, setUsuarios] = useState([])
    const [usuario, setUsuario] = useState(0)
    const [guardar, setGuardar] = useState(false)
    const [mensaje, setMensaje] = useState('')

    const { modify, setModify } = useContext(ContextStates)

    useEffect(() => {
        const showMessage = () => {
            if (mensaje !== "") {
                setTimeout(() => {
                    setMensaje("");
                }, 3000)
            }
        }
        showMessage()
    }, [mensaje])

    useEffect(() => {
        const getUsuarios = async () => {
            const formData = new FormData()
            formData.append('usuariocero', 1);
            formData.append('local', 1);
            try {
                const results = await axios({
                    url: Url + 'api/listUsrs.php',
                    method: 'POST',
                    data: formData,
                })
                console.log("usuarios ", results)
                setUsuarios(results.data.results);
                setUsuario(results.data.results[0].id)
            } catch (e) {
                console.log(e)
            }
        }
        getUsuarios()
    }, [])

    useEffect(() => {
        const getProductos = async () => {
            const formData = new FormData()
            formData.append("usuario", usuario)
            try {
                const results = await axios({
                    url: Url + 'api/getRepartoProductos.php',
                    method: 'POST',
                    data: formData,
                })
                //console.log("extrae ", results.data.results)
                setProductos(results.data.results);
            } catch (e) {
                console.log(e)
            }
        }
        getProductos()
    }, [modify, usuario])

    const handleSetCantidadI = (value, index) => {
        setGuardar(true)
        let rData = [...productos]
        rData.forEach(element => {
            if (element.idproducto === index) {
                let auxMonto = element.monto;
                element.cantidadinicial = value
                let aux = parseFloat(element.monto) * (parseFloat(element.cantidadinicial) - parseFloat(element.cantidadfinal));
                element.montoventas = aux;
                return
            }
        });
        setProductos(rData)
    }

    const handleIncrement = (index) => {
        let rData = [...productos]
        rData.forEach(element => {
            if (element.idproducto === index) {
                const currentValue = parseFloat(element.cantidadinicial) || 0;
                element.cantidadinicial = currentValue + 1;
                let aux = parseFloat(element.monto) * (parseFloat(element.cantidadinicial) - parseFloat(element.cantidadfinal));
                element.montoventas = aux;
                return
            }
        });
        setProductos(rData)
        setGuardar(true)
    }

    const handleDecrement = (index) => {
        let rData = [...productos]
        rData.forEach(element => {
            if (element.idproducto === index) {
                const currentValue = parseFloat(element.cantidadinicial) || 0;
                if (currentValue > 0) {
                    element.cantidadinicial = currentValue - 1;
                    let aux = parseFloat(element.monto) * (parseFloat(element.cantidadinicial) - parseFloat(element.cantidadfinal));
                    element.montoventas = aux;
                }
                return
            }
        });
        setProductos(rData)
        setGuardar(true)
    }

    const handleSetCantidadF = (e, index) => {
        let rData = [...productos]
        rData.forEach(element => {
            if (element.idproducto === index) {
                element.cantidadfinal = e
                let aux = parseFloat(element.monto) * (parseFloat(element.cantidadinicial) - parseFloat(element.cantidadfinal));
                element.montoventas = aux;
                return
            }
        });
        console.log("llega al final ")
        setProductos(rData)
    }

    const setRepartoProductos = async () => {
        if (guardar) {
            setGuardar(false)
            const auxReparto = JSON.stringify(productos)
            const formData = new FormData()
            formData.append('reparto', auxReparto);
            formData.append('usuario', usuario);

            try {
                const results = await axios({
                    url: Url + 'api/genReparto.php',
                    method: 'POST',
                    data: formData,
                })
                if (results.data.results.val === 2 || results.data.results.val === 3) {
                    setMensaje("Reparto asignado de manera correcta");
                }
                let aux = modify + 1;
                setModify(aux)
            } catch (e) {
                console.log(e)
            }
        }
    }

    return (
        <div className='min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50'>
            {/* Header */}
            <div className="bg-gradient-to-r from-blue-600 via-blue-700 to-indigo-700 text-white py-6 px-4 shadow-lg">
                <div className="max-w-6xl mx-auto">
                    <h1 className="text-3xl font-bold mb-2 flex items-center gap-2"><FaTruck /> Gestión de Repartos</h1>
                    <p className="text-blue-100">Administra los productos para reparto</p>
                </div>
            </div>

            <div className="max-w-6xl mx-auto px-0 py-8">
                {/* User Selector Card */}
                {usuarios && (
                    <div className='bg-white rounded-xl shadow-lg p-6 mb-6 border border-gray-200'>
                        <label className='text-gray-700 font-semibold mb-3 text-lg flex items-center gap-2'>
                            <FaUser /> Seleccionar Usuario
                        </label>
                        <select
                            className='py-3 px-4 w-full rounded-lg bg-white border-2 border-gray-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all duration-200 text-gray-800 font-medium cursor-pointer hover:border-blue-400'
                            id='sUsuario'
                            value={usuario}
                            onChange={(e) => setUsuario(e.target.value)}
                        >
                            {usuarios.map((item, index) => (
                                <option key={index} value={item.id}>{item.nombre}</option>))
                            }
                        </select>
                    </div>
                )}

                {/* Products Table Card */}
                {typeof productos !== 'undefined' && usuario !== 0 && (
                    <div className='bg-white rounded-xl shadow-lg overflow-hidden border border-gray-200'>
                        {/* Table Header */}
                        <div className='bg-gradient-to-r from-blue-600 to-indigo-600 text-white py-4 px-6'>
                            <h2 className='text-xl font-bold'>Productos para Reparto</h2>
                        </div>

                        {/* Table */}
                        <div className='overflow-x-auto'>
                            <table className='w-full'>
                                <thead>
                                    <tr className='bg-gradient-to-r from-blue-50 to-indigo-50 border-b-2 border-blue-200'>
                                        <th className='py-4 px-2 sm:px-6 text-left text-sm font-bold text-gray-700 uppercase tracking-wider'>Producto</th>
                                        <th className='py-4 px-2 sm:px-6 text-center text-sm font-bold text-gray-700 uppercase tracking-wider'>Cantidad a llevar</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {typeof productos !== 'undefined' && productos.map((item, index) => (
                                        <tr
                                            key={index}
                                            className={`transition-all duration-200 border-b border-gray-100 ${item.cantidadinicial && item.cantidadinicial >= 1
                                                ? 'bg-gradient-to-r from-green-50 to-emerald-50 hover:from-green-100 hover:to-emerald-100'
                                                : 'hover:bg-gray-50'
                                                }`}
                                        >
                                            <td className='py-1 px-2 sm:px-6'>
                                                <div className='flex items-center gap-2'>
                                                    <FaBox className='text-gray-500 hidden sm:inline' />
                                                    <span className='font-medium text-gray-800 text-sm sm:text-base'>{item.descripcion}</span>
                                                </div>
                                            </td>
                                            <td className='py-1 px-2 sm:px-6'>
                                                <div className='flex items-center justify-center gap-1 sm:gap-2'>
                                                    <button
                                                        type='button'
                                                        onClick={() => handleDecrement(item.idproducto)}
                                                        className='w-8 h-8 sm:w-10 sm:h-10 rounded-lg bg-gradient-to-br from-red-500 to-red-600 hover:from-red-600 hover:to-red-700 text-white font-bold text-lg sm:text-xl shadow-md hover:shadow-lg transform hover:scale-105 transition-all duration-200 flex items-center justify-center active:scale-95'
                                                    >
                                                        −
                                                    </button>
                                                    <input
                                                        type='number'
                                                        className='w-12 sm:w-20 h-8 sm:h-10 px-1 sm:px-3 text-center border-2 border-gray-300 rounded-lg font-semibold text-base sm:text-lg bg-white focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all duration-200'
                                                        value={!item.cantidadinicial ? '' : item.cantidadinicial}
                                                        onChange={(e) => handleSetCantidadI(e.target.value, item.idproducto)}
                                                        min="0"
                                                    />
                                                    <button
                                                        type='button'
                                                        onClick={() => handleIncrement(item.idproducto)}
                                                        className='w-8 h-8 sm:w-10 sm:h-10 rounded-lg bg-gradient-to-br from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white font-bold text-lg sm:text-xl shadow-md hover:shadow-lg transform hover:scale-105 transition-all duration-200 flex items-center justify-center active:scale-95'
                                                    >
                                                        +
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                        {/* Message Alert */}
                        {mensaje !== '' && (
                            <div className='p-4 mx-6 my-4 bg-gradient-to-r from-green-500 to-emerald-600 text-white text-center text-lg font-semibold rounded-xl shadow-lg animate-pulse flex items-center justify-center gap-2'>
                                <FaCheckCircle /> {mensaje}
                            </div>
                        )}

                        {/* Save Button */}
                        <div className='p-6'>
                            <button
                                type='button'
                                className={`w-full py-4 rounded-xl font-bold text-lg shadow-lg transition-all duration-300 transform hover:scale-[1.02] active:scale-[0.98] ${guardar
                                    ? 'bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 text-white shadow-blue-500/50'
                                    : 'bg-gray-200 text-gray-400 cursor-not-allowed'
                                    }`}
                                disabled={!guardar}
                                onClick={() => setRepartoProductos()}
                            >
                                {guardar ? <><FaSave className='inline' /> Guardar Cambios</> : <><FaCheck className='inline' /> Todo Guardado</>}
                            </button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
}

export default FormRepartosView